"use client";

import Link from "next/link";

import { Logo } from "@/components/typography/Logo";
import { useMobileNavVisible } from "@/lib/hooks/useMobileNavVisible";

const MobileLogoBar = () => {
  const visible = useMobileNavVisible();

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-50 bg-sand-10 flex items-center justify-center py-3 lg:hidden transition-transform duration-300 ease-out ${
        visible ? "translate-y-0" : "-translate-y-full"
      }`}
    >
      <Link href="/" aria-label="Dialetics">
        <Logo className="h-5 w-auto" />
      </Link>
    </div>
  );
};

export { MobileLogoBar };
